import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import EmergencyBanner from "@/components/EmergencyBanner";
import Header from "@/components/Header";
import CityMarquee from "@/components/CityMarquee";
import AprilBanner from "@/components/AprilBanner";
import TrustBadges from "@/components/TrustBadges";
import BusinessShowcase from "@/components/BusinessShowcase";
import LoiretBanner from "@/components/LoiretBanner";
import ReviewsSection from "@/components/ReviewsSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import FloatingCallButton from "@/components/FloatingCallButton";
import ReviewsWidget from "@/components/ReviewsWidget";
import VisitTracker from "@/components/VisitTracker";

const Layout = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    // Sur la page d'accueil, le bloc Certifications est rendu DANS la page
    // (juste après le hero/première photo). Sur les autres pages, on le garde en haut.
    const showTopTrustBadges = pathname !== "/";

    return (
        <div className="min-h-screen flex flex-col bg-[#FAFAFA] text-[#0A0A0A]" data-testid="site-layout">
            <VisitTracker />
            <EmergencyBanner />
            <Header />
            <CityMarquee />
            <AprilBanner />
            <main className="flex-1">
                {showTopTrustBadges && <TrustBadges />}
                <Outlet />
            </main>
            <BusinessShowcase />
            <ReviewsSection />
            <FAQSection />
            <LoiretBanner />
            <Footer />
            <FloatingCallButton />
            <ReviewsWidget />
        </div>
    );
};

export default Layout;
